<template>
  <section class="invoice-preview-wrapper">
    <!-- Alert for no userObjective found -->
    <b-alert variant="danger" :show="!userObjective && !loading">
      <h4 class="alert-heading">Erreur lors de la récupération des données de la section</h4>
      <div class="alert-body">
        Aucune section trouvée avec cet identifiant. Consultez
        <b-link class="alert-link" :to="{ name: 'section' }">la liste des sections</b-link>
        pour d’autres sections.
      </div>
    </b-alert>

    <!-- Main content when userObjective is available -->
<!--    <b-row v-if="userObjective" class="invoice-preview" id="contenu-a-imprimer">-->
    <b-row v-if="userObjective && canAccessObjectivePage" class="invoice-preview" id="contenu-a-imprimer">
      <b-col cols="12" xl="9" md="8">
        <div ref="contentToPrint">


          <b-card no-body class="invoice-preview-card invoice-spacing m-0 pt-2">
            <b-card-title class="text-center"> Liste des Objectifs Année : {{ userObjective.years }}</b-card-title>

            <b-badge :variant="userObjective.valid ? 'primary' : 'warning'" class="badge-glow">
              {{ userObjective.valid ? 'Validé' : 'Non Validé' }}
            </b-badge>
            <b-card-body no-body class="border mt-1 mb-12">

              <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                <div>
                  <p class="card-text mb-25">{{ userObjective.users.lastName }} {{ userObjective.users.firstName }}
                  </p>
                  <p class="card-text mb-25">{{ userObjective.users.fonction ? userObjective.users.fonction : '' }}
                  </p>
                  <p class="card-text mb-0">{{ userObjective.users.directions ? userObjective.users.directions.name :
                    ''
                  }}</p>


                </div>
                <div class="mt-md-0 mt-2">

                  <!-- <div class="invoice-date-wrapper">
                      <p class="invoice-date-title">Date Création:</p>
                      <p class="invoice-date">{{ formatDate(userObjective.dateCreate) }}</p>
                    </div> -->
                  <div class="invoice-date-wrapper">
                    <p class="invoice-date-title">Date d'embauche:</p>
                    <p class="invoice-date">{{ formatDate(userObjective.users.fonctionDate) }}</p>
                  </div>
                  <div class="invoice-date-wrapper">
                    <p class="invoice-date-title">Poids des Objectifs dans l’Évaluation (%) : </p>
                    <p class="invoice-date"> {{ userObjective.note ? userObjective.note : 50 }} %</p>
                  </div>
                </div>
              </div>
            </b-card-body>

            <!-- Objectives table -->
            <b-table-lite responsive :items="objectives" :fields="fields">
              <template #cell(#Id)="data">
                <span class="text-nowrap">
                  OBJ - 00{{ data.item.idObjective }}
                </span>
              </template>
              <template #cell(objectifs)="data">
                <b-card-text class="font-weight-bold mb-70  text-justify">{{ data.item.objectif }}</b-card-text>
              </template>
              <template #cell(indicateurs)="data">
                <b-card-text class="font-weight-bold mb-50  text-justify">{{ data.item.description }}</b-card-text>
              </template>
              <template #cell(Note)="data">
                <b-card-text class="text-nowrap">{{ data.item.note }} %</b-card-text>
              </template>
            </b-table-lite>

            <hr>




            <b-card v-if="userObjective.description || userObjective.descriptionAutomatic"
              title="Commentaire de Validation">
              <b-card-text class="text-danger">{{ userObjective.descriptionAutomatic
              }}</b-card-text>
              <b-card-text>
                {{ userObjective.description
                }} </b-card-text>
            </b-card>

            <b-table responsive :items="signatureUser" :fields="['Profile', 'Nom', 'Fonction', 'Date', 'Status']"
              class="mb-0">
              <template #cell(Profile)="data">
                <b-card-text class="text-nowrap">{{ data.item.titre }}</b-card-text>
              </template>
              <template #cell(Nom)="data">
                <b-card-text class="text-nowrap">{{ data.item.users.lastName }} {{ data.item.users.firstName }}</b-card-text>
              </template>
              <template #cell(Fonction)="data">
                <b-card-text class="text-nowrap">{{ data.item.users.fonction }}</b-card-text>
              </template>

              <template #cell(Date)="data">
                <b-card-text class="text-nowrap">{{ formatDate(data.item.dateCreate) }}</b-card-text>
              </template>

              <template #cell(Status)="data">
                <b-badge pill :variant="data.item.variant">
                  {{ data.item.text }}
                </b-badge>
              </template>
            </b-table>

          </b-card>
        </div>
      </b-col>

      <!-- Action buttons -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions">
        <b-row>

          <!-- Commentaire de Rejet v-if="isHierarchyModifying() && userObjective.descriptionRejet"-->
          <b-col v-if="userObjective.descriptionRejet" sm="12" >
            <b-card title="Rejet des objectifs" class="mb-1">

              <div>
                <h6 class="mb-1">
                  Commentaire :
                </h6>

                <b-form-group class="mb-0">
                  <b-card-text class="text-danger">
                    {{ userObjective.descriptionRejet }}
                  </b-card-text>
                </b-form-group>
              </div>
            </b-card>
          </b-col>

          <!-- Zone d'acceptation des objectifs -->
          <b-col sm="12" v-if="!isHierarchyModifying() && !isHierarchyN2() && !isRapport && userObjective.validHierachy && !userObjective.valid">
            <b-card title="Acceptation des objectifs" class="mb-2">

              <div>
                <p class="mb-2">
                  Veuillez noter que vous avez 5 jours calendaires pour effectuer cette validation. Passé ce délai, la
                  validation sera automatique.
                </p>

                <b-form-group>
                  <b-card-text>
                  </b-card-text>

                  <b-form-checkbox checked="true" class="custom-control-primary" name="check-button"
                    v-model="isObjectiveValidated" switch>
                    Accepter
                  </b-form-checkbox>
                </b-form-group>
                <validation-observer ref="Commentaire1" tag="form">

                  <b-form-group v-if="!(isObjectiveValidated && (!comment || comment.length === 0))">
                    <label for="textarea-default" class="font-weight-bold">Commentaire de Validation</label>
                    <validation-provider name="Commentaire" rules="required|noHtmlCode"
                                         v-slot="{ errors, failedRules }">

                    <b-form-textarea id="textarea-default" v-model="comment"  @input="validateComment" placeholder="Ajoutez un commentaire..."
                      rows="3" />
                      <small class="text-danger" v-if="failedRules.required">
                        Un commentaire est requis.
                      </small>

                      <small class="text-danger" v-else-if="failedRules.noHtmlCode">
                        Le commentaire ne doit pas contenir de code HTML ou JavaScript.
                      </small>
                    </validation-provider>

                  </b-form-group>

                  <b-button variant="primary" class="mb-75" block @click="submitValidation">
                    Envoyer
                  </b-button>
                </validation-observer>

              </div>
            </b-card>
          </b-col>

          <!-- Affichage de la date de rencontre -->
          <b-col cols="12" v-if="(userObjective.status === 'PROPOSE' || (userObjective.status === 'REJETE' && userObjective.rejetHierachyn===1)) && userObjective.dateObjectifPrevu">
            <b-card class="mb-2">
              <b-card-title>Date de validation</b-card-title>

              <p class="mb-0"> Le rendez-vous pour la validation des objectifs est prévue le : <strong>{{ userObjective.dateObjectifPrevu }}</strong> </p>                  <b-card-text></b-card-text>
            </b-card>
          </b-col>

          <b-col>
            <b-row>

              <b-col cols="12">
                <b-card>
                  <b-button variant="outline-secondary" class="mb-75" block @click="generatePDF">
                    Télécharger
                  </b-button>
                  <b-button v-if="!userObjective.dateObjectifPrevu && isHierarchyModifying() && !isRapport " v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" class="mb-75" block
                            @click="dateObjectif">
                    Définir la date de validation
                  </b-button>
                  <b-button v-if="canRejectObjective && !isRapport" v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            variant="outline-secondary" class="mb-75" block @click="showRejectModal">
                    Rejeter
                  </b-button>
                  <b-button v-if="canEditObjective && !isRapport" v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            variant="outline-secondary" class="mb-75" block
                            :to="{ name: 'objectif', query: { id: userObjective.id } }">
                    Modifier
                  </b-button>
                  <b-button v-if="canValidObjective && !isRapport" v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            variant="outline-secondary" class="mb-75" block
                            @click="openConfirmValidN2Modal">
                    Valider
                  </b-button>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Modal de rejet -->
    <validation-observer ref="validationReject" tag="form">
      <b-modal id="reject-modal" title="Rejeter les objectifs" v-model="isRejectModal" centered size="sm"
        @ok="submitRejection" ok-title="Confirmer le rejet">
        <!-- Champ de commentaire avec validation -->
        <validation-provider name="Commentaire de rejet"  rules="required|noHtmlCode"
                             v-slot="{ errors, failedRules }">
          <label for="rejection-comment" class="mt-2 font-weight-bold">Commentaire de rejet</label>
          <b-form-textarea id="rejection-comment" v-model="rejectionComment" @input="validateRejectionComment"
            placeholder="Expliquez la raison du rejet..." rows="3" :state="errors.length === 0 ? null : false" />

          <small class="text-danger" v-if="failedRules.required">
            Un commentaire est requis.
          </small>

          <small class="text-danger" v-else-if="failedRules.noHtmlCode">
            Le commentaire ne doit pas contenir de code HTML ou JavaScript.
          </small>
        </validation-provider>
      </b-modal>
    </validation-observer>
    <b-modal id="modal-sm" v-model="isModalActive" modal-class="modal-primary" ok-only ok-title="OK" centered size="sm"
             :title="'Date'" @ok="confirmDateObjectif">
      <b-row>
        <b-col md="12">
          <b-form-group>
            <h5>Date pour la validation des Objectifs</h5>
            <!-- <flat-pickr v-model="inlineDate" class="form-control"
                :config="{ enableTime: true, dateFormat: 'd-m-y H:i' }" /> -->
            <flat-pickr v-model="inlineDate" class="form-control" :config="{
              inline: true,
              enableTime: true,
              dateFormat: 'd-m-y H:i',
              minDate: new Date(),
              maxDate: new Date(new Date().setDate(new Date().getDate() + 14)),
              defaultDate: new Date(),
              locale: French
            }" />

          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
        id="confirm-valid-n2-modal"
        v-model="isConfirmValidN2Modal"
        title="Confirmation de l'objectif"
        ok-title="Oui, valider"
        cancel-title="Annuler"
        cancel-variant="outline-secondary"
        centered
        @ok.prevent="confirmValidN2"
        @cancel="cancelValidN2"
        @close="cancelValidN2"
    >
      <p class="mb-1">
        Vous êtes sur le point de <strong>valider</strong> les objectifs.
      </p>
      <p>Voulez-vous vraiment continuer ?</p>
    </b-modal>
  </section>
</template>

<script>
import {
  BFormGroup,
    BFormCheckbox,
  BModal,
  BFormTextarea,
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCardTitle,
  BCol,
  BLink,
  BRow,
  BTable,
  BTableLite
} from 'bootstrap-vue';
import router from '@/router';
import Ripple from 'vue-ripple-directive';
import {
  getIdUserObjective,
  updateDateUserObjective,
  updateUserObjective,
  updateValidObjectif
} from '@/services/UserObjectiveService';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { required } from '@validations'
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import autoTable from "jspdf-autotable";
import {getJsonFromStorage} from "@/util/storageUtils";
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
flatpickr.localize(French);
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {getBase64Image} from "@/util/getBase64Image";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import logoSIRAT from '@/assets/images/logo/LOGO_SIRAT_couleur.png'
import {French} from "flatpickr/dist/l10n/fr";
const forbiddenPatterns = [
      /<\s*\/?\s*[a-zA-Z][a-zA-Z0-9_-]*\s*.*?>/i,
      /<\s*script/i,
      /<\s*style/i,
      /on\w+\s*=/i,
      /(javascript|data|vbscript):/i,
      /(\$\{[^}]*\}|\{\{[^}]*\}\}|#\{[^}]*\})/,
      /(%3C|%3E|&#\d+;|&#x[0-9a-fA-F]+;|\\u[0-9a-fA-F]{4}|\\x[0-9a-fA-F]{2})/i,
  /<!--|--\>/i
];
extend('noHtmlCode', {
  validate: (value) => {
    if (!value) return true; // vide ok
    // Vérifie chaque pattern du tableau
    for (const pattern of forbiddenPatterns) {
      if (pattern.test(value)) {
        return false; // interdit si un pattern match
      }
    }
    return true; // tout est ok
  },
  message: 'Le texte ne doit pas contenir de code HTML ou JavaScript.',
});

export default {
  directives: {
    Ripple
  },
  components: {
    // VueGoodTable,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormCheckbox,
    BModal,
    BFormTextarea,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    // BImg,BImg,
    BTable,
    BBadge,
    BCardTitle,
    flatPickr,
    // VueHtml2pdf,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      isRapport: false,
      userObjective: null,
      objectives: [],
      signatureObjective: [],
      signatureImageUrl: null,
      signatureUser: [],
      loading: true,
      isObjectiveValidated: false,
      comment: null,
      isRejectModal: false,
      isModalActive:false,
      isConfirmValidN2Modal: false,
      rejectionComment: "",
      fields: [
        { key: '#Id', label: 'ID', class: 'w-id-col', thClass: 'w-id-col text-center' },
        { key: 'Objectifs', label: 'Objectifs' },
        { key: 'Indicateurs', label: 'Indicateurs' },
        { key: 'Note', label: 'Note' }
      ],
      inlineDate:null,

    };
  },
  computed: {
    French() {
      return French
    },

    canAccessObjectivePage() {
      if (!this.userObjective) return false;
      const userData = this.getStoredUserData();

      if (!userData) return false;

      if (this.isRapport) return true;

      const isOwner = userData.id === this.userObjective.users.id;



      const isManager = this.isHierarchyModifying();
      const isN2 = this.isHierarchyN2();


      return isOwner || isManager || isN2;
    },

    canRejectObjective() {
      const status = this.userObjective.status;
      const isN1 = this.isHierarchyModifying();
      const isN2 = this.isHierarchyN2();
      if (isN1) {
        return (status === 'PROPOSE'  || (status === 'REJETE' && this.userObjective.rejetHierachyn === 1))&& !this.userObjective.dateObjectifPrevu ;
      }

      if (isN2) {
        // N+2 peut rejeter tant que c'est à son niveau ou rejeté par lui
        return status === 'TRANSMIT_HIERARCHY_2' ||
            (status === 'REJETE' && this.userObjective.rejetHierachyn === 2);
      }

      return false;
    },

    canEditObjective() {
      if (!this.userObjective || !this.userObjective.status) return false;

      const status = this.userObjective.status;
      const isManager = this.isHierarchyModifying();
      const isN2 = this.isHierarchyN2();


      switch (status) {
        case 'PROPOSE':
          if (!isManager) {

            return true;
          } else if (isManager && this.userObjective.dateObjectifPrevu) {

            return true;
          }

          return false;
        case 'VALIDE_HIERARCHY_1':
          return !!isManager;


        case 'VALIDE_HIERARCHY_2':
          return isN2;


        case 'REJETE':

          if (!isManager) {
            return true;
          }

          if (isManager) {
            if (isN2) {
              return this.userObjective.rejetHierachyn === 2;
            } else {
              return  this.userObjective.dateObjectifPrevu;
            }
          }

          return false;

        case 'VALIDE_COLLABORATEUR':
          return false;
        case 'TRANSMIT_HIERARCHY_2':

          if (isManager || isN2) return true

          return !!isManager;

        default:
          return false;
      }
    },

    canValidObjective() {
      return this.isHierarchyN2() && !this.userObjective.valid;
    },
  },

  methods: {
    confirmDateObjectif() {
      const userData = this.getStoredUserData();


      this.userObjective.dateObjectifPrevu=this.inlineDate;
      updateDateUserObjective(this.userObjective.id ,userData.id,this.userObjective).then(result=>{
        if (result.dateObjectifPrevu) {
          this.showToast("Date enregistrée avec succès", "success", "BellIcon");
        } else {
          this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
        }

      })
      .catch(error => {
        this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");

        console.error("Erreur lors de la récupération des données :", error)

      });

    },
    openConfirmValidN2Modal() {
      this.isConfirmValidN2Modal = true;
    },

    confirmValidN2() {
      // L'utilisateur a confirmé → on valide
      this.userObjective.validHierachy = true;
      this.updateObjective();

      // Mets à jour la timeline
      this.addAllSignatureUser(this.userObjective);

      // On ferme la modal
      this.isConfirmValidN2Modal = false;

      // Optionnel : toast de succès immédiat
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Validation effectuée',
          icon: 'CheckIcon',
          variant: 'success',
          text: 'Les objectifs ont été validés avec succès.'
        }
      });
    },

    cancelValidN2() {
      // L'utilisateur a annulé → on ferme juste la modal
      this.isConfirmValidN2Modal = false;
    },

    async updateObjective() {
      const userData = this.getStoredUserData()


      this.userObjective = await updateUserObjective(this.userObjective.id, userData.id, this.userObjective)


      // Mets à jour la timeline
      this.addAllSignatureUser(this.userObjective);


      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Objectif mis à jour avec succès',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
      localStorage.removeItem('tempObjectives');
      await this.$router.push({name: 'objectif_print', params: {id: newUserObjective.id, isRapport: 0}})

    },


    dateObjectif() {
      this.isModalActive = true;
    },
    validateRejectionComment() {
      if (!this.rejectionComment) return false;


      return !forbiddenPatterns.some(pattern => pattern.test(this.rejectionComment));
    },

    validateComment() {
      if (!this.comment) return

      return !forbiddenPatterns.some(pattern => pattern.test(this.comment));

    },
    // telechargerPDF() {
    //   const nomFichier = "tableau_des_Objectifs_" +
    //     this.userObjective.users.lastName + "_" +
    //     this.userObjective.users.firstName + ".pdf";
    //   const element = this.$refs.contentToPrint; // Référence à l'élément à imprimer
    //   const options = {
    //     filename: nomFichier,
    //     margin: [5, 5, 5, 5], // Marges en millimètres : [haut, gauche, bas, droite]
    //     image: { type: 'jpeg', quality: 0.9 },
    //     html2canvas: { scale: 2 },
    //     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    //     pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    //
    //   };
    //   html2pdf().from(element).set(options).save();
    //
    // },


    async generatePDF() {
      const logoBase64 = await getBase64Image(logoSIRAT)

      const n1 = this.signatureUser.find(sig => sig.titre.includes("Manager N°1"))
      const n2 = this.signatureUser.find(sig => sig.titre.includes("Manager N°2"))

      const content = [
        {
          columns: [
            { image: logoBase64, width: 120 },
            {
              stack: [
                {
                  text: `OBJECTIFS ${this.userObjective.years}`,
                  alignment: 'right',
                  fontSize: 12,
                  bold: false,
                  color: '#005cb9'
                },
                {
                  text: `Statut : ${this.userObjective.valid ? 'Validé' : 'Non Validé'}`,
                  alignment: 'right',
                  fontSize: 11,
                  margin: [0, 5, 0, 0]
                }
              ]
            }
          ]
        },

        { text: 'I - Informations Générales', style: 'section' },

        {
          table: {
            widths: ['35%', '65%'],
            body: [
              [
                // 'Personne occupant le poste :',
                // `${this.userObjective.users.lastName} ${this.userObjective.users.firstName}`
                {
                  text: 'Personne occupant le poste :',
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                },
                {
                  text: `${this.userObjective.users.lastName} ${this.userObjective.users.firstName}`,
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                }
              ],
              [
                this.userObjective.users.services?.name ? 'Service :' : 'Direction :',
                this.userObjective.users.services?.name ||
                this.userObjective.users.directions?.name
              ],
              ['Fonction / Titre :', this.userObjective.users.fonction],
              ['Date de prise de service :', this.formatDate(this.userObjective.users.fonctionDate)]
            ]
          },
           layout: 'noBorders',

          margin: [0, 12, 0, 16]
        }
      ]

      //  Manager N°1
      if (n1) {
        content.push({
          table: {
            widths: ['35%', '65%'],
            body: [
              [
                {
                  text:  'Supérieur Hiérarchique 1 :',
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                },
                {
                  text: `${n1.users.lastName} ${n1.users.firstName}`,
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                }
              ],
              [
                n1.users.services?.name ? 'Service :' : 'Direction :',
                n1.users.services?.name || n1.users.directions?.name
              ],
              ['Fonction / Titre :', n1.users.fonction],
              ['Date de prise de service :', this.formatDate(n1.users.fonctionDate)]
            ]
          },
         layout: 'noBorders',

          margin: [0, 12, 0, 16]
        })
      }

      //  Manager N°2
      if (n2) {
        content.push({
          table: {
            widths: ['35%', '65%'],
            body: [
              [
                {
                  text:  'Supérieur Hiérarchique 2 :',
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                },
                {
                  text: `${n2.users.lastName} ${n2.users.firstName}`,
                  fillColor: '#f2f2f2',
                  margin: [5, 4, 5, 4]
                }
              ],
              [
                n2.users.services?.name ? 'Service :' : 'Direction :',
                n2.users.services?.name || n2.users.directions?.name
              ],
              ['Fonction / Titre :', n2.users.fonction],
              ['Date de prise de service :', this.formatDate(n2.users.fonctionDate)]
            ]
          },
          layout: 'noBorders'
        })
      }

      //  Section Objectifs
      content.push(
          { text: 'II - Objectifs', style: 'section' },
          {
            table: {
              headerRows: 1,
              widths: [50, '*', '*', 50],
              body: [
                [
                  { text: '#Id', style: 'tableHeader', alignment: 'center' },
                  { text: 'Objectifs', style: 'tableHeader' },
                  { text: 'Indicateurs', style: 'tableHeader' },
                  { text: 'Note', style: 'tableHeader', alignment: 'center' }
                ],
                ...this.objectives.map(obj => ([
                  { text: `OBJ-${String(obj.idObjective).padStart(3,'0')}`, style: 'tableBody', alignment: 'center' },
                  { text: obj.objectif, style: 'tableBody', alignment: 'justify' },
                  { text: obj.description, style: 'tableBody', alignment: 'justify' },
                  { text: `${obj.note} %`, style: 'tableBody', alignment: 'center' }
                ]))
              ]
            },
            layout: {
              hLineColor: '#575353',
              vLineColor: '#575353',
              hLineWidth: () => 0.5,
              vLineWidth: () => 0.5
            }
          }
      )
//  Section Commentaire de Validation
      if (this.userObjective.description || this.userObjective.descriptionAutomatic) {
        content.push({ text: 'Commentaire de Validation', style: 'section' })

        if (this.userObjective.descriptionAutomatic) {
          content.push({
            text: this.userObjective.descriptionAutomatic,
            color: 'red',
            margin: [0, 4, 0, 4],
            alignment: 'justify'
          })
        }

        if (this.userObjective.description) {
          content.push({
            text: this.userObjective.description,
            color: 'black',
            margin: [0, 4, 0, 8],
            alignment: 'justify'
          })
        }
      }

      //  Section III - Signatures / Validation
      if (this.signatureUser?.length > 0) {
        content.push({ text: 'III - Validation', style: 'section' })
        content.push({
          table: {
            widths: ['35%', '30%', '35%'],
            body: [
              [
                { text: 'Nom & Prénom(s)', style: 'tableHeader' },
                { text: 'Date', style: 'tableHeader' },
                { text: 'Statut', style: 'tableHeader', alignment: 'center' }],
                ...this.signatureUser.map(sig =>(
                [

                  { text: `${sig.users.lastName} ${sig.users.firstName}`, style: 'tableBody', alignment: 'justify' },
                  { text: this.formatDate(sig.dateCreate), style: 'tableBody', alignment: 'justify' },
                  { text: sig.text, style: 'tableBody', alignment: 'center' }

                ]
              ))

            ]
          },
          layout: {
            hLineColor: '#575353',
            vLineColor: '#575353',
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5
          },
          margin: [0, 12, 0, 12],
        })

      }

      const docDefinition = {
        pageMargins: [40, 20, 40, 50],
        defaultStyle: {
          fontSize: 10
        },
        content,
        styles: {
          section: {
            fontSize: 12,
            bold: false,
            color: '#005cb9',
            margin: [0, 15, 0 ,5]
          },
          tableHeader: {
            bold: true,
            fontSize: 11,
            color: '#000000',
            fillColor: '#f2f2f2',
            margin: [3, 3, 3, 3]
          },
          tableBody: {
            fontSize: 10,
            color: '#000000',
            margin: [3, 4, 3, 4]
          }
        },

        footer: function(currentPage, pageCount) {
          const BLUE = '#005cb9';
          const BLACK = '#020202';

          return {
            stack: [
              {
                text: "Société des Infrastructures Routières et de l’Aménagement du Territoire (SIRAT SA), Société Anonyme au capital social de 100.000.000 F.CFA -",
                fontSize: 8, color: BLUE, alignment: 'center', margin: [0, 10, 0, 0]
              },
              {
                text: "Siège : Immeuble SCI Trait d’Union, von Obama Beach, Quartier Ahwanleko Plage, Cotonou -",
                fontSize: 8, color: BLUE, alignment: 'center', margin: [0, 2, 0, 0]
              },
              {
                text: "Tél : 21 60 45 45 - IFU : 3 2018 1038 7789 - RCCM RB/COT/18 B 22225 ; contact@sirat.bj",
                fontSize: 8, color: BLUE, alignment: 'center', link: "mailto:contact@sirat.bj", margin: [0, 2, 0, 0]
              },
              {
                text: `Page ${currentPage} / ${pageCount}`,
                fontSize: 8, color: BLACK, alignment: 'right', margin: [0, 4, 10, 0]
              }
            ]
          };
        }

      }

      pdfMake.createPdf(docDefinition).download(
          `Objectifs_${this.userObjective.users.lastName}.pdf`
      )
    },



 footer: function(currentPage, pageCount) {
      const BLUE = '#005cb9'; // ou [0, 92, 185]
      return {
        stack: [
          { text: "Société des Infrastructures Routières et de l’Aménagement du Territoire (SIRAT SA), Société Anonyme au capital social de 100.000.000 F.CFA -", fontSize: 8, color: BLUE, alignment: 'center' },
          { text: "Siège : Immeuble SCI Trait d’Union, von Obama Beach, Quartier Ahwanleko Plage, Cotonou -", fontSize: 8, color: BLUE, alignment: 'center' },
          {
            columns: [
              { text: "Tél : 21 60 45 45 - IFU : 3 2018 1038 7789 - RCCM RB/COT/18 B 22225 ;", fontSize: 8, color: BLUE, alignment: 'right' },
              { text: "contact@sirat.bj", link: "mailto:contact@sirat.bj", fontSize: 8, color: BLUE, alignment: 'left' }
            ],
            margin: [0, 2, 0, 0]
          },
          { text: `Page ${currentPage} / ${pageCount}`, fontSize: 8, color: BLUE, alignment: 'center', margin: [0, 2, 0, 0] }
        ]
      };
    },

    async submitValidation() {
      const isValid = await this.$refs.Commentaire1.validate();

      if (!isValid) {
        this.showToast("Veuillez corriger les erreurs (commentaire requis ou invalide).", "danger", "AlertTriangleIcon");
        return;
      }

      // Tout est valide → on envoie
      await this.confirmEvalueObjective();
    },

    async confirmEvalueObjective() {

      try {

        this.userObjective.valid = this.isObjectiveValidated;
        this.userObjective.description = this.comment;
        this.userObjective = await updateValidObjectif(this.userObjective.id, this.getStoredUserData().id, this.userObjective);

        this.addAllSignatureUser(this.userObjective);

        if(this.comment && this.isObjectiveValidated) {
          this.showToast("Objectifs validés avec commentaire !", "success", 'EditIcon');
        } else if(this.comment && !this.isObjectiveValidated) {
          this.showToast("Commentaire ajouté avec succès !", "success", "EditIcon")
        } else if(!this.comment && this.isObjectiveValidated) {
          this.showToast("Objectifs validés avec succès !")
        }

      } catch(error) {
        const data = error.response?.data;
        if (data) {
          if (!Array.isArray(data.errors) ) {

              this.showToast("Erreur dans la validation Objectif validé.", "danger", 'EditIcon');


            }
        }
      }

    },

    showToast (message, color, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon: icon,
          timeout: 8000,
          text: message,
          variant: color,
        },
      });
    },
    async fetchUserObjectiveData() {
      const userObjectiveId = router.currentRoute.params.id;
      const rapport = this.$route.params.isRapport
      this.isRapport = rapport === 1;

      if (userObjectiveId) {
        const userData = this.getStoredUserData();

        try {
          this.userObjective = await getIdUserObjective(userObjectiveId,userData.id);

          if (!this.canAccessObjectivePage) {
            if (this.$route.name !== 'profile') {
              await this.$router.replace({ name: 'profile' });
            }
            return;
          }
          this.objectives = this.userObjective.objectifs.sort((a, b) => a.idObjective - b.idObjective);


          this.comment = this.userObjective.description
          this.isObjectiveValidated = this.userObjective.valid
          this.addAllSignatureUser(this.userObjective);

        } catch (error) {
          console.error('Error fetching userObjective data:', error);
        } finally {
          this.loading = false;
        }

      } else {
        console.error('No userObjective ID found in route params.');
        this.loading = false;
      }
    },

    addAllSignatureUser(userObjective) {
      this.signatureUser = [];
      const {
        status,
        validHierachy: isValid,
        users,
        dateCreate,
        signatureObjective = [],
        dateValid,
        rejetHierachyn
      } = userObjective;

      this.addSignatureUser("Collaborateur :", users, dateCreate, "Proposé", "light-success");

      const n1 = signatureObjective.find(item => item.hierarchyN === 1);
      const n2 = signatureObjective.find(item => item.hierarchyN === 2);


      switch (status) {
        case 'PROPOSE':

          if (n1) this.addSignatureUser("Manager N°1 :", n1.users, null, "En attente de validation", "light-warning");

          break;

        case 'VALIDE_HIERARCHY_1':
          if (n1) {
            this.addSignatureUser("Manager N°1 :", n1.users, n1.confirmDate, "Validé", "light-success");
          }

          this.addSignatureUser("Collaborateur :", users, null, "En attente de validation finale", "light-warning");

          break;
        case 'TRANSMIT_HIERARCHY_2':
          if (n1) {
            this.addSignatureUser("Manager N°1 :", n1.users, n1.confirmDate, "Validé", "light-success");
          }
          if (n2) {
            this.addSignatureUser("Manager N°2 :", n2.users, null, "En attente de validation", "light-warning");
          }
          break;
        case 'VALIDE_HIERARCHY_2':
          if (n1) {
            this.addSignatureUser("Manager N°1 :", n1.users, n1.confirmDate, isValid ? "Validé" : "Rejeté", "light-success");
          }
          if (n2) {
            this.addSignatureUser("Manager N°2 :", n2.users, n2.confirmDate, "Validé", "light-success");
          }
          if (isValid) {
            this.addSignatureUser("Collaborateur :", users, null, "En attente de validation finale", "light-warning");
          } else {
            this.addSignatureUser("Manager N°1 :", n1?.users, null, "En attente de correction", "light-warning");
          }
          break;

        case 'REJETE':
          if (rejetHierachyn === 1) {
            this.addSignatureUser("Manager N°1 :", n1.users, n1.confirmDate, "Rejeté", "light-danger");
            this.addSignatureUser("Collaborateur :", users, null, "En attente de correction", "light-warning");
            break;
          }
          else if (rejetHierachyn === 2) {
            if (n1) {
              this.addSignatureUser("Manager N°1 :", n1.users, n1.confirmDate, "Validé", "light-success");
            }
            if (n2) this.addSignatureUser("Manager N°2 :", n2.users, n2.confirmDate, "Rejeté", "light-danger");
            if (n1) this.addSignatureUser("Manager N°1 :", n1.users, null, "En attente de correction", "light-warning");
            break;
          }
          break;
        case 'VALIDE_COLLABORATEUR':  // <-- ici on ajoute la validation finale / clôture

          if (n1) {
            this.addSignatureUser("Manager N°1 :", n1.users, n1.confirmDate, isValid ? "Validé" : "Rejeté", "light-success");
          }
          if (n2) {
            this.addSignatureUser("Manager N°2 :", n2.users, n2.confirmDate, "Validé", "light-success");
          }
          this.addSignatureUser("Collaborateur :", users, dateValid, "Validation finale - Objectifs clôturés", "light-success");
          break;

      }
    },
    addSignatureUser(titre, users, dateCreate, text, variant) {
      // Vérifiez que les données sont valides
      if (!users) return;
      this.signatureUser.push({
        titre,
        users,
        dateCreate,
        text,
        variant,

      });
    },

    isHierarchyN2() {


      if ( this.userObjective && this.userObjective.signatureObjective) {
        const userData = this.getStoredUserData();

        const userSignatureObjective = this.userObjective.signatureObjective.find(sigObj => sigObj.users.id === userData.id);
        if (userSignatureObjective && userSignatureObjective.hierarchyN === 2) {
          return true;
        }
      }
      return false;
    },

    isHierarchyModifying() {
      //
      // return userData && userData.id !== this.userObjective.users.id;
      if (this.userObjective && this.userObjective.signatureObjective) {
        const userData = this.getStoredUserData();

        const userSignatureObjective = this.userObjective.signatureObjective.find(sigObj => sigObj.users.id === userData.id);
        return userSignatureObjective && userSignatureObjective.hierarchyN ===1;

      }


    },


    formatDate(date) {

      if (!date) return '';


      if (Array.isArray(date)) {
        const [year, month, day] = date;

        return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
      }


      if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        const [year, month, day] = date.substring(0, 10).split('-');
        return `${day}-${month}-${year}`;
      }
      if (typeof date === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
        const [day, month, year] = date.split('-');
        return `${day}-${month}-${year}`;
      }
      if (date instanceof Date && !isNaN(date)) {
        return date.toLocaleDateString('fr-FR');
      }

      return ''; // Cas non reconnu
    },
    getUriToBase64Image(base64Image) {
      return `data:image/png;base64,${base64Image}`;
    },
    printInvoice() {
      window.print();
    },
    getStoredUserData() {
      const storedUserData = getJsonFromStorage('userData');
      return storedUserData ? storedUserData : null;
    },

    // Soumission du rejet avec validation
    async submitRejection(newUserObjective) {


      if (!this.rejectionComment || this.rejectionComment.trim() === '') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erreur',
            icon: 'AlertTriangleIcon',
            text: 'Le commentaire de rejet est requis.',
            variant: 'danger',
          },
        });
        return;
      }

      // Continuez seulement si les validations passent
      try {
        const userData = this.getStoredUserData();


        // CLONE, pas mutation directe
        const payload = {
          ...this.userObjective,
          descriptionRejet: this.rejectionComment,
        };

        const newUserObjective = await updateUserObjective(
            this.userObjective.id,
            userData.id,
            payload
        );

        // COMMIT SEULEMENT ICI
        this.userObjective = newUserObjective;

        this.addAllSignatureUser(newUserObjective);

        this.rejectionComment = '';
        this.isRejectModal = false;

        // Toast de succès
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Objectifs rejetés avec succès',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });

      } catch (error) {
        this.isRejectModal = true;
        const data = error.response?.data;
        if (data) {
          if (!Array.isArray(data.errors) ) {
            let message = "Une erreur est survenue.";
              if (data.message) {
                message = data.message;
              }
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Échec du rejet des objectifs',
                icon: 'XIcon',
                html: message,
                variant: 'danger',
              },
            });

          }
        }


      }
    },
    showRejectModal() {
      this.isRejectModal = true;
    },

  },

  mounted() {
    this.fetchUserObjectiveData();
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>

<style lang="scss">
.w-id-col {
  width: 1%;
  max-width: 90px;
  white-space: nowrap;
}

@media print {

  /* CSS for printing */
  body {
    background-color: transparent !important;
  }

  nav.header-navbar {
    display: none;
  }

  .main-menu {
    display: none;
  }

  .header-navbar-shadow {
    display: none !important;
  }

  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }

  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }

  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            >.col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }

    .text-justify {
      text-align: justify;
    }

    table {
      break-inside: avoid;
    }

    tr {
      break-inside: avoid;
      break-after: auto;
    }

  }
}
</style>
